import { getCart } from "../getCart/getCart";
import { setCountryCodeInSession } from "../setCountryCodeInSession/setCountryCodeInSession";
import { setCustomerInformationInLocalStorage } from "../setCustomerInformationInLocalStorage/setCustomerInformationInLocalStorage";

export const loadPreOrder = (preorderCode) => {
  return (dispatch, getState, { api }) => {
    return api.loadPreOrder(preorderCode).then(
      async (data) => {
        if (data.result) {
          let customerData = data.result.customer || data.result.registrant;

          const country = customerData && customerData.country;

          // Set countryCode in the session, so getCart is called with updated country
          country && dispatch(setCountryCodeInSession(country));

          const dataEntries = Object.entries(customerData);
          // Prefill customer data
          dataEntries.forEach(([fieldName, fieldValue]) => {
            if (fieldValue && fieldValue !== "") {
              dispatch(
                setCustomerInformationInLocalStorage(fieldName, fieldValue),
              );
            }
          });

          // Reload the Cart
          await dispatch(getCart());

          return { wasSuccessful: true };
        } else {
          return { wasSuccessful: false };
        }
      },
      (error) => {
        window.location = "/error.do";

        return { wasSuccessful: false };
      },
    );
  };
};
